export default {
      id: "pattern-plus-left-gris-usage",
      viewBox: "0 0 139 200",
      url: "../icon/" + "icons.svg#pattern-plus-left-gris-usage",
      toString: function () {
        return this.url;
      }
    }